// src/components/Error404/Error404.js
import React, { useEffect, useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import axios from '../../api/axiosClient';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ProductMain from '../MainPage/ProductMain';
import { getFromCache, saveToCache } from '../utils/cache';
import { getSliderSettings } from '../utils/sliderSettings';
import ErrorNotice from '../common/ErrorNotice';

const CACHE_KEY = '404-categories';

const Error404 = () => {
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/');
  };

  useEffect(() => {
    const cached = getFromCache(CACHE_KEY);
    if (cached) {
      setCategories(cached);
      return;
    }

    axios.get('/api/main-categories/')
      .then(response => {
        const categoryRequests = response.data.map(category =>
          axios.get(`/api/compositions/?categories=${category.slug}`)
            .then(prodResponse => ({ ...category, products: prodResponse.data.results }))
            .catch(() => ({ ...category, products: [] }))
        );
        Promise.all(categoryRequests).then(categoriesWithProducts => {
          setCategories(categoriesWithProducts);
          saveToCache(CACHE_KEY, null, categoriesWithProducts);
          setError('');
        });
      })
      .catch(() => {
        setError('Не удалось загрузить рекомендации.');
      });
  }, []);

  return (
    <Box sx={{ textAlign: 'center', padding: '50px' }}>
      <Typography variant="h1" color="lightpink">404</Typography>
      <Typography variant="h4" color="textSecondary" gutterBottom>
        Страница не найдена
      </Typography>
      <Typography variant="body1" color="textSecondary" paragraph>
        Такой страницы не существует, но у нас много красоты!
      </Typography>
      <Button variant="contained" color="primary" onClick={handleGoBack}>
        Вернуться на главную
      </Button>
      <Box sx={{ mt: 6 }}>
        <ErrorNotice>{error}</ErrorNotice>
        {categories.map(category => {
          const products = category.products || [];
          return (
            <Box key={category.slug} sx={{ mt: 6, overflow: 'hidden', width: '100%' }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 6 }}>
                <Typography variant="h2">{category.name}</Typography>
                <Button
                  style={{ color: '#f2003c' }}
                  onClick={() => navigate(`/${category.parent}/${category.slug}`)}
                >
                  Смотреть всё
                </Button>
              </Box>
              {products.length > 0 && (
                <Slider {...getSliderSettings(products.length, { autoplaySpeed: 4000 })}>
                  {products.map(product => (
                    <Box key={product.id} sx={{ flexGrow: 1 }}>
                      <ProductMain product={product} />
                    </Box>
                  ))}
                </Slider>
              )}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default Error404;
